import { Directive } from '@angular/core';

/**
 * Marks the control a page writes in place of the component's own.
 *
 * It exists so the component can tell whether the page brought a trigger: without a marker there is
 * no way to know whether a projection slot was filled, and the default would have to be drawn on
 * top of whatever the page wrote.
 *
 * ```html
 * <mib-upload …>
 *   <button mibUploadTrigger mibButton mode="outlined" theme="secondary">
 *     <svg mib-icon name="upload"></svg>
 *     Upload video
 *   </button>
 * </mib-upload>
 * ```
 *
 * Nothing is bound to it. The whole drop area opens the file picker, so a trigger inside it is
 * carried along without a handler of its own.
 */
@Directive({ selector: '[mibUploadTrigger]' })
export class MibUploadTriggerDirective {}
